export const COUNTRIES_URL = ':namespace/countries/list';
export const COUNTRIES_QUERY_KEY = 'countries';
